import React from 'react';
import {Button, Dialog, Typography} from '@mui/material';

import overbookingDesktopImg from 'presentation/assets/images/overbooking@2x.webp';
import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {AppointmentBookingEnum} from 'main/analytics/gaTagsEnum';
import {PrevButton} from 'presentation/components/Carrousel/ArrowsAndDotsButtons';
import {
	StyledActionsContainer,
	StyledImageContainer,
	StyledSkipButton,
	StyledStackContent,
	StyledPrevButtonContainer,
} from './styles';
import {OverbookingProps} from './types';
import {useBookingConfirmationDrawer} from '../../hooks/useBookingConfirmationDrawer';
import {BookingTypeEnum} from '../../constants';
import {useHostName} from 'presentation/hooks';

const {healthBook, telehealthBook, overbooking} = translations['pt-br'].privateFlow.bookingFlow;
const {skip} = translations['pt-br'].commons;

export function Overbooking({open, setOpen}: OverbookingProps) {
	const {isMobile} = useMediaQueries();
	const {isNotredameSaude} = useHostName();
	const {setSelectedServiceType, handleOpenBookingConfirmationDrawer} =
		useBookingConfirmationDrawer();

	const handleClose = () => {
		setOpen(false);
	};

	const handleOpenBookingConfirmationForHealth = () => {
		setSelectedServiceType(BookingTypeEnum.HEALTH);
		handleClose();
		handleOpenBookingConfirmationDrawer();
	};

	const handleOpenBookingConfirmationForTelehealth = () => {
		setSelectedServiceType(BookingTypeEnum.TELEHEALTH);
		handleClose();
		handleOpenBookingConfirmationDrawer();
	};

	return (
		<Dialog
			fullScreen={isMobile}
			open={open}
			onClose={handleClose}
			aria-labelledby="book-telehealth">
			<StyledPrevButtonContainer>
				<PrevButton onClick={handleClose} />
			</StyledPrevButtonContainer>
			<StyledSkipButton
				onClick={handleOpenBookingConfirmationForHealth}
				variant="outlined"
				data-tag-id={AppointmentBookingEnum.CLICK_PULAR_OVERBOOKING}>
				{skip}
			</StyledSkipButton>

			<StyledImageContainer>
				<img alt="" src={overbookingDesktopImg} />
			</StyledImageContainer>
			<StyledStackContent>
				<Typography variant="h6">{overbooking.title}</Typography>
				<Typography textAlign="center">{overbooking.description}</Typography>
			</StyledStackContent>
			<StyledActionsContainer>
				<Button
					size="large"
					variant="outlined"
					onClick={handleOpenBookingConfirmationForHealth}
					data-tag-id={AppointmentBookingEnum.CLICK_CONSULTA_PRESENCIAL}>
					{healthBook}
				</Button>
				<Button
					size="large"
					variant={isNotredameSaude ? 'outlined' : 'contained'}
					onClick={handleOpenBookingConfirmationForTelehealth}
					endIcon={<Icon name="remember-me-filled" />}
					data-tag-id={AppointmentBookingEnum.CLICK_TELECONSULTA}>
					{telehealthBook}
				</Button>
			</StyledActionsContainer>
		</Dialog>
	);
}
